"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const arrowDownIcon = `url('data:image/svg+xml;utf8,<svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="960px" height="560px" viewBox="0 0 960 560" enable-background="new 0 0 960 560" xml:space="preserve"><g id="Rounded_Rectangle_33_copy_4_1_"><path d="M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z"/></g></svg>')`;
const styles = {
    select: (width) => {
        const widthValue = width ? Number(width) - 5 : 115;
        return (0, react_1.css) `
      padding: 0 5px;
      border: 0.55px solid #cacaca;
      font-size: 14px;
      width: ${widthValue}px;
      margin: 0;
      height: 100%;
      background: ${arrowDownIcon} no-repeat right white;
      appearance: none;
      background-position-x: calc(100% - 5px);
      background-size: 15px 15px;
      border-radius: 5px;
      align-self: center;

      &:focus,
      input:focus {
        outline: none;
      }

      &:required:invalid {
        color: #666;
      }
    `;
    },
};
const Select = (0, react_2.forwardRef)(function Select(props, ref) {
    const { items, style = { width: 100 }, onChange = () => null, defaultValue, value, name = '', className = '', placeholder = '', itemValueField = 'value', itemTextField = 'label', returnValue = true, textRender, } = props;
    const handleOnChanged = (0, react_2.useCallback)((e) => {
        const [option] = e.target.selectedOptions;
        const selectedData = JSON.parse(option.dataset.value);
        onChange(returnValue ? selectedData[itemValueField] : selectedData);
    }, [itemValueField, onChange, returnValue]);
    return ((0, jsx_runtime_1.jsxs)("select", { ref: ref, css: styles.select(style?.width), name: name, onChange: handleOnChanged, defaultValue: defaultValue, value: value, className: className, style: style, required: true, children: [placeholder && ((0, jsx_runtime_1.jsx)("option", { value: "", disabled: true, children: placeholder })), items.map((option) => ((0, jsx_runtime_1.jsx)("option", { value: option[itemValueField], "data-value": JSON.stringify(option), children: textRender?.(option[itemTextField]) || option[itemTextField] }, JSON.stringify(option))))] }));
});
exports.default = Select;
